import * as React from "react";
import styled from "styled-components";
import { Button } from "./Button";
import { theme } from "./theme";
import { CustomCss, Position, Tooltip } from "./Tooltip";

interface TooltipProps {
  content?: React.ReactNode;
  position?: Position;
  okText?: string;
  onOk?: () => void;
  onDismiss?: () => void;
  hide?: boolean;
  customCss?: CustomCss;
  zIndex?: number;
}

export class StaticTooltip extends React.Component<TooltipProps> {
  render() {
    const {
      children,
      position = Position.TOP,
      okText,
      onOk,
      onDismiss,
      hide,
      customCss,
      content,
      zIndex = 1001,
    } = this.props;
    if (hide) {
      return <>{children}</>;
    }

    return (
      <>
        <Tooltip
          position={position}
          trigger={"static"}
          closable={false}
          zIndex={zIndex}
          customCss={{
            ...customCss,
            wrapper: {
              maxWidth: 300,
              ...customCss?.wrapper,
            },
            arrow: {
              color: "#93227E",
              ...customCss?.arrow,
            },
          }}
          content={
            <TooltipContent>
              {content}
              {okText && (
                <TooltipOkButton onClick={onOk}>{okText}</TooltipOkButton>
              )}
            </TooltipContent>
          }
        >
          {children}
        </Tooltip>
        {onDismiss && (
          <TooltipOverlay
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onDismiss();
            }}
          />
        )}
      </>
    );
  }
}

export const TooltipOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0);
  z-index: 1000;
  pointer-events: auto;
`;

export const TooltipContent = styled.div`
  padding: 16px;
  color: #fff;
  background: #93227e;
  border-radius: 5px;
`;

export const TooltipOkButton = styled(Button)`
  border: 1px solid ${theme.white};
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  background: #ffffff;
  color: #333f48;
  margin-top: 16px;
  padding: 0px 16px;
  min-width: 106px;
  height: 36px;

  &:hover {
    cursor: pointer;
    border: 1px solid #d2d5da;
    background: ${theme.linkWater};
  }
`;
